import { getEventLabel } from '@eagle/react-common';
import { DateTime } from 'luxon';

export const toEventLabel = (eventTypeId: string, feature?: string): string => {
  if (feature) {
    const translated = getEventLabel(feature, eventTypeId);
    if (translated && translated !== eventTypeId) return translated;
  }

  return eventTypeId
    .split('-')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
};

export const toEventTime = (value: unknown): DateTime => {
  if (value instanceof Date) return DateTime.fromJSDate(value);
  if (typeof value === 'string') return DateTime.fromISO(value);
  return DateTime.now();
};

export const stripTrailingStatusDot = (value: string): string => {
  return value.replace(/\s*[\u25CF\u25CB\u2B24\u{1F534}\u{1F7E5}\u{1F7E0}\u{1F7E1}\u{1F7E2}\u{1F535}\u{1F7E3}\u{1F7E4}]\s*$/u, '').trim();
};
